// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full Form Wrapper */
.PatientContactForm_contactForm__195SY {
  color: #fff;
  padding: 2em;
  position: relative;
  max-width: 500px; /* Limiting the max width to make it more manageable */
  /* margin: 0 auto; Center the form */
}

/* Input Styling */
.PatientContactForm_contactFormFormControl__m\\+Z0B {
  width: 100%; /* Ensures input fields take up full container width */
  border-radius: 1.5em;
  border: 1px solid rgba(255, 255, 255, 0.5);
  transition: border-color 0.3s ease;
}

.PatientContactForm_contactFormFormControl__m\\+Z0B:focus {
  outline: none;
  border-color: #aab5b7;
}

.PatientContactForm_contactFormFormControl__m\\+Z0B::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.PatientContactForm_contactFormTextDanger__pqeG7 {
  color: #aab5b7 !important;
}

/* Submit Button */
.PatientContactForm_contactFormFormSubmit__7YkOM {
  color: #444;
  background-color: #fff !important;
  border-color: rgb(79, 81, 79) !important;
  border-radius: 2em;
  width: 80%;
  /* padding: 10px 0; */
  font-size: 1rem;
}

.PatientContactForm_contactFormFormSubmit__7YkOM:disabled {
  background-color: #ccc; /* Grey out button when disabled */
  color: #999; /* Grey text */
  cursor: not-allowed;
}

/* Form Layout */
.PatientContactForm_contactFormFormSection__guOdK {
  display: flex;
  flex-direction: column;
  align-items: stretch; /* Ensures the form fields take up full width */
  gap: 1rem;
}

/* Consent Checkbox */
.PatientContactForm_contactFormCheckboxWrapper__7d36S {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  margin-top: 1em; /* Reduced margin */
}

/* Overlay Loader */
.PatientContactForm_overlay__a-ZJz {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 17, 17, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 1em;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .PatientContactForm_contactFormFormControl__m\\+Z0B {
    width: 100%; /* Ensures responsiveness on small screens */
  }

  .PatientContactForm_contactFormFormSubmit__7YkOM {
    width: 100%;
  }

  .PatientContactForm_contactFormCheckboxWrapper__7d36S {
    justify-content: center;
    margin-left: 0;
  }
}

/* Affirmation Text Style */
.PatientContactForm_affirm__owsgX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%; /* Ensures it doesn't overflow */
  font-size: 0.875em; /* Slightly larger text for better readability */
  color: rgba(255, 255, 255, 0.8); /* Subtle color for better contrast */
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/PATIENT_CONTACT/PatientContactForm.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE,sDAAsD;EACxE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,WAAW,EAAE,sDAAsD;EACnE,oBAAoB;EACpB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;EAC1D,WAAW,EAAE,cAAc;EAC3B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB,EAAE,+CAA+C;EACrE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe,EAAE,mBAAmB;AACtC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW,EAAE,4CAA4C;EAC3D;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU,EAAE,gCAAgC;EAC5C,kBAAkB,EAAE,gDAAgD;EACpE,+BAA+B,EAAE,qCAAqC;AACxE","sourcesContent":["/* Full Form Wrapper */\n.contactForm {\n  color: #fff;\n  padding: 2em;\n  position: relative;\n  max-width: 500px; /* Limiting the max width to make it more manageable */\n  /* margin: 0 auto; Center the form */\n}\n\n/* Input Styling */\n.contactFormFormControl {\n  width: 100%; /* Ensures input fields take up full container width */\n  border-radius: 1.5em;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  transition: border-color 0.3s ease;\n}\n\n.contactFormFormControl:focus {\n  outline: none;\n  border-color: #aab5b7;\n}\n\n.contactFormFormControl::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.contactFormTextDanger {\n  color: #aab5b7 !important;\n}\n\n/* Submit Button */\n.contactFormFormSubmit {\n  color: #444;\n  background-color: #fff !important;\n  border-color: rgb(79, 81, 79) !important;\n  border-radius: 2em;\n  width: 80%;\n  /* padding: 10px 0; */\n  font-size: 1rem;\n}\n\n.contactFormFormSubmit:disabled {\n  background-color: #ccc; /* Grey out button when disabled */\n  color: #999; /* Grey text */\n  cursor: not-allowed;\n}\n\n/* Form Layout */\n.contactFormFormSection {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; /* Ensures the form fields take up full width */\n  gap: 1rem;\n}\n\n/* Consent Checkbox */\n.contactFormCheckboxWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n  margin-top: 1em; /* Reduced margin */\n}\n\n/* Overlay Loader */\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(17, 17, 17, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-radius: 1em;\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .contactFormFormControl {\n    width: 100%; /* Ensures responsiveness on small screens */\n  }\n\n  .contactFormFormSubmit {\n    width: 100%;\n  }\n\n  .contactFormCheckboxWrapper {\n    justify-content: center;\n    margin-left: 0;\n  }\n}\n\n/* Affirmation Text Style */\n.affirm {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80%; /* Ensures it doesn't overflow */\n  font-size: 0.875em; /* Slightly larger text for better readability */\n  color: rgba(255, 255, 255, 0.8); /* Subtle color for better contrast */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactForm": `PatientContactForm_contactForm__195SY`,
	"contactFormFormControl": `PatientContactForm_contactFormFormControl__m+Z0B`,
	"contactFormTextDanger": `PatientContactForm_contactFormTextDanger__pqeG7`,
	"contactFormFormSubmit": `PatientContactForm_contactFormFormSubmit__7YkOM`,
	"contactFormFormSection": `PatientContactForm_contactFormFormSection__guOdK`,
	"contactFormCheckboxWrapper": `PatientContactForm_contactFormCheckboxWrapper__7d36S`,
	"overlay": `PatientContactForm_overlay__a-ZJz`,
	"affirm": `PatientContactForm_affirm__owsgX`
};
export default ___CSS_LOADER_EXPORT___;
